import { Flex, LoadingIcon } from "basis";
import { ApplicationStatus } from "components/IncreaseCreditLimit/types";
import { GetApplicationResponseData } from "components/IncreaseCreditLimit/utils";
import { Account } from "library/accounts/types";
import { useAccountInfo } from "library/hooks/useAccountInfo";
import { useEffect } from "react";
import { useCliContext } from "../hooks/useCliContext";
import { UnableToIncrease } from "../IneligibleCli/UnableToIncrease";
import { ActionTypes } from "../types";
import { getApplicationInfo } from "../utils";
import { CliEligiblePage } from "./CliEligiblePage";

type Props = {
  location: {
    state?: {
      account: Account;
    };
  };
};

export const NzIncreaseCreditLimit = ({ location }: Props) => {
  const { state, dispatch } = useCliContext();
  const account = location.state?.account;
  const accountInfo = useAccountInfo(location.state?.account);
  const getApplicationUrl = account?.links.find(
    (link) => link.rel === "credit_limit_increase",
  )?.href;
  let ScreenComponent;
  const isLandingPage = !state.account?.product_id;

  useEffect(() => {
    // Initialize value for CLI
    if (isLandingPage && account && accountInfo) {
      dispatch({
        type: ActionTypes.LANDING_PAGE,
        account,
        accountInfo,
      });
    }

    if (isLandingPage && getApplicationUrl) {
      getApplicationInfo(getApplicationUrl).then(
        (applicationInfo: GetApplicationResponseData) => {
          const {
            application: { status },
          } = applicationInfo;

          dispatch({
            type: ActionTypes.LOAD_APPLICATION_STATUS,
            status,
          });
        },
      );
    }
  }, [isLandingPage, dispatch, account, accountInfo, getApplicationUrl]);

  switch (state.status) {
    case ApplicationStatus.CLI_NOT_ELIGIBLE:
      ScreenComponent = UnableToIncrease;
      break;
    case ApplicationStatus.CLI_ELIGIBLE:
      ScreenComponent = CliEligiblePage;
      break;
    default:
      // TODO: more status will be introduced in coming user stories
      return (
        <Flex height="200" placeItems="center">
          Coming Soon
        </Flex>
      );
  }
  return state.status ? (
    <ScreenComponent location={location} />
  ) : (
    <Flex height="200" placeItems="center">
      <LoadingIcon size="medium" />
    </Flex>
  );
};
